import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ReactTable from '../../../../components/ReactTable';
import { IoClose } from 'react-icons/io5';
import { FiCheck, FiEye, FiLoader } from 'react-icons/fi';
import { createColumnHelper } from '@tanstack/react-table';
import { CiEdit } from 'react-icons/ci';
import { GoEye, GoTrash } from "react-icons/go";
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';


function LearningVideoPlaylistPage() {
  const params = useParams();
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false); // Global loading state
  const [searchQuery, setSearchQuery] = useState('');
  const [showEntries, setShowEntries] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
const [newCategory, setNewCategory] = useState({ title: '', description: '', file: null });
const [editCategory, setEditCategory] = useState(null);
  const [filePreview, setFilePreview] = useState(null); // Preview the uploaded file
  const [modalLoading, setModalLoading] = useState(false); // Loading state for modal

  const { token,user,authToken } = useSelector((state) => state.login);
  const columnHelper = createColumnHelper();

  console.log("user",user)
  console.log("token",token)
  console.log("authToken",authToken)

  const base = `${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_API_TYPE}`;

  // Fetch categories from the API with pagination
  const fetchPublicCollaterals = async (page = 1, limit = 10, query = '') => {
    setLoading(true); // Set loading to true before API call
    try {
      const response = await axios.get(`${base}/learningVideos/${params?.id}/playlist`, {
        headers: {
          'Authorization': `Bearer ${authToken || token}`,
        },
      });
      setCategories(response?.data?.data?.list);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error('Error fetching assets:', error);
    } finally {
      setLoading(false); // Set loading to false after the API call is complete
    }
  };

  // Handle input changes (for new category, description, and file)
  const handleCategoryInputChange = (e) => {
    const { name, value } = e.target;
    setNewCategory((prev) => ({ ...prev, [name]: value }));
  };

  // Handle file input change (for file upload)
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewCategory((prev) => ({ ...prev, file }));
      setFilePreview(URL.createObjectURL(file)); // Preview the file
    }
  };

  // Handle new category form submission
  const handleCreateCategory = async () => {
    if (!newCategory.title || !newCategory.file) {
      toast.info("Please fill all fields and upload a document.");
      return;
    }

    const formData = new FormData();
    formData.append('name', newCategory.title);
formData.append('description', newCategory.description);
formData.append('file', newCategory.file);
formData.append('categoryId', params?.id);


    setModalLoading(true); // Start loading before API call
    try {
      await axios.post(`${base}/learningVideos/${params?.id}/playlist`, formData, {
        headers: {
          'Authorization': `Bearer ${authToken || token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      toast.success("Asset created");
      setNewCategory({ title: '', description: '', file: null });
      setFilePreview(null);
      fetchPublicCollaterals();
      setIsModalOpen(false);
    } catch (error) {
      toast.error(error?.response.data.message || "Something went wrong, please try again!");
      console.error('Error creating asset:', error);
    } finally {
      setModalLoading(false); // End loading after the API call completes
    }
  };

  // Handle delete asset
  const handleDeleteAddets = async () => {
    setLoading(true); // Start loading before delete API call
    try {
      if (categoryToDelete) {
        await axios.delete(`${base}/learningVideos/${categoryToDelete}/playlist`, {
          headers: {
            Authorization: `Bearer ${authToken || token}`,
          },
        });
        toast.success("Assets deleted");
        fetchPublicCollaterals();
        setIsDeleteModalOpen(false);
        setCategoryToDelete(null);
      }
    } catch (error) {
      toast.error(error?.response.data.message || "Something went wrong, please try again!");
      console.error('Error deleting asset:', error);
    } finally {
      setLoading(false); // End loading after delete operation completes
    }
  };

  // Handle edit category click (open edit modal)
  const handleEditCategory = (category) => {
    setEditCategory(category);
    setIsModalOpen(true);
  };

  // Handle category edit input change
  const handleEditCategoryInputChange = (e) => {
    const { name, value } = e.target;
    setEditCategory((prev) => ({ ...prev, [name]: value }));
  };

  const handleViewPage=(id)=>{
    // navigate(`/manage-resource/training/learning/playlist/${id}`)
     navigate(`/manage-resource/training/learning/playlist/${id}`, {
      state: { 
        id: params.id,
        
      },
    });
  }

  // Handle category edit form submission
  const handleEditCategorySubmit = async () => {
    console.log("editCategory",editCategory)
    if (!editCategory.title) {
      toast.info("Please fill in all fields.");
      return;
    }

    const formData=new FormData()

    
   formData.append('name', editCategory.title);
formData.append('description', editCategory.description);
formData.append('file', newCategory?.file || editCategory?.file);
formData.append('categoryId', params?.id);

    

    setModalLoading(true); // Start loading before edit API call
    try {
      const response = await axios.put(`${base}/learningVideos/${editCategory.id}/playlist`, formData, {
        headers: {
          Authorization: `Bearer ${authToken || token}`,
        },
      });
      fetchPublicCollaterals();
      setIsModalOpen(false);
      setEditCategory(null);
    } catch (error) {
      console.error('Error editing category:', error);
    } finally {
      setModalLoading(false); // End loading after edit operation completes
    }
  };

  // Fetch assets when component mounts
  useEffect(() => {
    fetchPublicCollaterals(currentPage, showEntries, searchQuery);
  }, [currentPage, showEntries, searchQuery]);

  const hostedcolumns = [
    columnHelper.accessor((row) => row.name, {
      id: 'Name',
      cell: (info) => info.renderValue(),
      header: () => <span>Name</span>,
    }),
    columnHelper.accessor(row => row.description, {
  id: 'Description',
  cell: info => info.renderValue(),
  header: () => <span>Description</span>,
}),

    columnHelper.accessor((row) => row.thumbnail, {
      id: 'Thumbnail',
      cell: (info) => info.renderValue(),
      header: () => <span>Thumbnail</span>,
    }),
    columnHelper.accessor((row) => row, {
      id: 'action',
      cell: (info) => {
        const category = info?.row?.original;

        return (
          <div className="flex justify-end gap-5">
            <span className='' onClick={() => handleViewPage(category?.id)}>
             <FiEye />

            </span>
            <span onClick={() => handleEditCategory(category)}>
              <CiEdit />
            </span>
            <span onClick={() => { setCategoryToDelete(category.id); setIsDeleteModalOpen(true); }}>
              <GoTrash />
            </span>
          </div>
        );
      },
      header: () => (
        <div className="flex justify-end">
          <span>Action</span>
        </div>
      ),
    }),
  ];

  const handleBack = () => {
    navigate("/manage-resource/training");
  };

  // Loader Component using React Icons FiLoader
  const Loader = () => (
    <div className="flex justify-center items-center">
      <FiLoader className="animate-spin text-4xl text-blue-600" />
    </div>
  );


  return (
    <div className='mt-[100px] p-6'>
      <div className='w-full pl-5 pt-5'>
        <span onClick={handleBack} className='text-[#065697] cursor-pointer'>Back</span>
      </div>
      <div className="p-6 bg-gray-50 rounded-lg mt-[50px]">
        <div className="flex justify-between mb-6">
          <h2 className="text-2xl font-semibold text-gray-800">Learning Video PlayList Thumbnail</h2>
          <div className="flex items-center space-x-2">
            <button
              onClick={() => setIsModalOpen(true)}
              className="bg-[#065697] text-white p-3 rounded-md transition"
            >
              Add New
            </button>
          </div>
        </div>

        {/* Show Loader when loading is true */}
        {loading ? (
          <Loader />
        ) : (
          <div>
            {/* Table rendering */}
            {categories?.length > 0 && (
              <ReactTable key={JSON.stringify(categories)} defaultData={categories} columns={hostedcolumns} />
            )}
          </div>
        )}

        {/* New Asset Modal */}
       {/* Create / Edit Modal */}
{(isModalOpen || editCategory) && (
  <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
    <div className="bg-white p-6 rounded-lg w-1/3">
      <div className="flex justify-between items-center">
        <h3 className="text-xl font-semibold">
          {editCategory ? 'Edit Playlist Item' : 'Create New Playlist Item'}
        </h3>
        <IoClose
          className="cursor-pointer"
          onClick={() => {
            setIsModalOpen(false);
            setEditCategory(null);
          }}
        />
      </div>
      {console.log("editCategory",editCategory)}

      {/* Title Input */}
      <div className="mt-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">Name / Title</label>
        <input
          type="text"
          name="title"
          value={editCategory ? editCategory.name : newCategory.title}
          onChange={editCategory ? handleEditCategoryInputChange : handleCategoryInputChange}
          placeholder="Enter name or title"
          className="p-3 border rounded-md w-full"
        />
      </div>

      {/* Description Input */}
      <div className="mt-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
        <textarea
          name="description"
          value={editCategory ? editCategory.description || '' : newCategory.description}
          onChange={editCategory ? handleEditCategoryInputChange : handleCategoryInputChange}
          placeholder="Enter a short description"
          className="p-3 border rounded-md w-full h-24 resize-none"
        />
      </div>

      {/* File Upload */}
      <div className="mt-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">Upload File</label>
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="p-3 border rounded-md w-full"
        />
        {filePreview && (
          <div className="mt-2">
            <a
              href={filePreview}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600"
            >
              View uploaded file
            </a>
          </div>
        )}
      </div>
      <span>Only image allowed</span>

      {/* Loader / Submit */}
      {modalLoading ? (
        <div className="flex justify-center items-center mt-4">
          <Loader />
        </div>
      ) : (
        <div className="mt-4 flex justify-end">
          <button
            disabled={loading}
            onClick={editCategory ? handleEditCategorySubmit : handleCreateCategory}
            className="bg-[#065697] text-white p-3 rounded-md transition"
          >
            {editCategory ? 'Update' : 'Create'}
          </button>
        </div>
      )}
    </div>
  </div>
)}


        {/* Delete Confirmation Modal */}
        {isDeleteModalOpen && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
            <div onClick={() => setIsDeleteModalOpen(false)} className="bg-white p-6 rounded-lg w-1/3">
              <h3 className="text-xl font-semibold">Are you sure you want to delete this asset?</h3>
              <div className="mt-4 flex justify-end gap-4">
                <button
                  onClick={() => setIsDeleteModalOpen(false)}
                  className="bg-gray-300 text-black p-2 rounded-md"
                >
                  Cancel
                </button>
                <button
                  onClick={handleDeleteAddets}
                  disabled={loading}
                  className="bg-red-600 text-white p-2 rounded-md"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default LearningVideoPlaylistPage;
